// extracted by mini-css-extract-plugin
module.exports = {"dropDownAction":"TableActionDropdown_dropDownAction_3k2K8","spinAround":"TableActionDropdown_spinAround_rL50d"};